import { CustomLoadingOverlay } from './CustomLoadingOverlay';

export const components = { CustomLoadingOverlay };
